import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "../pages/Home.vue";
import ListaChat from "../pages/ListaChat.vue";
import AdminChat from "../pages/AdminChat.vue";
import AdminProductos from "../pages/AdminProductos.vue";
import AdminConfig from "../pages/AdminConfig.vue";
import AdminPalabras from "../pages/AdminPalabras.vue";
import AdminBan from "../pages/AdminBan.vue";
import AdminSideOffer from '../pages/AdminSideOffer.vue';
import Login from "../pages/Login.vue";
import allChat from "../pages/allChat";
import AdminLiveDebug from '../pages/AdminLiveDebug'
function guardMyroute (to, from, next) {
  let isAuthenticated = false;

  if (sessionStorage.getItem("uid")) {
    isAuthenticated = true;
  } else {
    isAuthenticated = false;
  }
  if (isAuthenticated) {
    next(); // allow to enter route
  } else {
    next("/login"); // go to '/login';
  }
}

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Home
  },
  {
    path: "/home",
    component: Home
  },
  {
    path: "/anfitrion",
    component: ListaChat
  },
  {
    path: "/allchat",
    component: allChat
  },
  {
    path: "/login",
    component: Login
  },
  {
    path: "/admin",
    component: AdminConfig,
    beforeEnter: guardMyroute
  },
  {
    path: "/ban",
    component: AdminBan,
    beforeEnter: guardMyroute
  },
  {
    path: "/chat",
    component: AdminChat,
    beforeEnter: guardMyroute
  },
  {
    path: "/productos",
    component: AdminProductos,
    beforeEnter: guardMyroute
  },
  {
    path: "/side-offer",
    component: AdminSideOffer,
    beforeEnter: guardMyroute
  },
  {
    path: "/config",
    component: AdminConfig,
    beforeEnter: guardMyroute
  },
  {
    path: "/palabras",
    component: AdminPalabras,
    beforeEnter: guardMyroute
  },
  {
    path: "/live-debug",
    component: AdminLiveDebug,
    beforeEnter: guardMyroute
  }
]

const router = new VueRouter({
  mode: "history",
  routes
})

export default router
